<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      append-to-body
      width="50%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="orgForm" :disabled="openType==='see'">
        <el-form-item label="姓名" prop="name">
          <el-input size="small" v-model="ruleForm.name"></el-input>
        </el-form-item>

        <el-form-item label="地址" prop="address">
          <el-input size="small" v-model="ruleForm.address"></el-input>
        </el-form-item>

        <el-form-item label="身份证号码" prop="idCard">
          <el-input size="small" v-model="ruleForm.idCard"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input size="small" v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input size="small" v-model="ruleForm.phone"></el-input>
        </el-form-item>


        
        <el-form-item label="身份证正面" prop="frontCard">
          <el-image class="avatar-uploader" fit="cover" @click="show(ruleForm.frontCard)" :src="ruleForm.frontCard" alt="" @contextmenu.prevent></el-image>
        </el-form-item>
        <el-form-item label="身份证背面" prop="backCard">
          <el-image class="avatar-uploader" fit="cover" @click="show(ruleForm.backCard)" :src="ruleForm.backCard" alt="" @contextmenu.prevent></el-image>
        </el-form-item>
        <el-form-item label="手持身份证" prop="mergeCard">
          <el-image class="avatar-uploader" fit="cover" @click="show(ruleForm.mergeCard)" :src="ruleForm.mergeCard" alt="" @contextmenu.prevent></el-image>
        </el-form-item>

        
        <!-- <el-form-item>
          <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button size="small" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item> -->
      </el-form>
    </el-dialog>
    <!-- 查看图片 -->
    <viewer :images="images" class="viewer" ref="viewer" @inited="inited" v-show="false" @contextmenu.prevent>
      <img v-for="(item, index) in images" :src="item" :key="index+'images'" class="image" @contextmenu.prevent>
    </viewer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    // openType: {
    //   type: String,
    //   required: true
    // },
    parentOpenType: {
      type: String,
      required: true
    },
    contractId: {
      type: String,
      required: true
    }
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!/^1[123456789]\d{9}$/.test(value)) {
        return callback(new Error('手机号格式不正确'));
      } else {
        return callback()
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)) {
        return callback(new Error('邮箱格式不正确'));
      } else {
        return callback()
      }
    };
    var checkCardNo = (rule, value, callback) => {
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        return callback(new Error('身份证号格式不正确'));
      } else {
        return callback()
      }
    };
    var checkCreditCode = (rule, value, callback) => {
      if (!/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(value)) {
        return callback(new Error('统一社会信用代码格式不正确'));
      } else {
        return callback()
      }
    };
    return {
      visible: false,
      title: '',
      ruleForm: {
        
      },
      // ruleForm: {
      //   type: '0',
      //   name: "", //姓名
      //   idNumber: "420923199901011234", // 证件号码
      //   phone: "18674074055",// 联系电话
      //   address: "湖北武汉", // 地址
      //   email: "515264616@qq.com", // 邮箱
      //   frontCard: 'https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/20200803030956/1bd4aed3776a421899b4b5d0bc6c46de.jpg', // 身份证正面
      //   backCard: 'https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/20200803030956/1bd4aed3776a421899b4b5d0bc6c46de.jpg', // 身份证反面
      //   mergeCard: 'https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/20200803030956/1bd4aed3776a421899b4b5d0bc6c46de.jpg', // 手持身份证
      //   creditCode: 'HK123456A1234B5678', // 统一社会信用代码
      //   businessLicense: 'https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/20200803030956/1bd4aed3776a421899b4b5d0bc6c46de.jpg', // 营业执照
      //   licenseFile: 'https://sxgongzhen.oss-cn-hangzhou.aliyuncs.com/20200803030956/1bd4aed3776a421899b4b5d0bc6c46de.jpg', // 许可资质
      // },
      disabled: false,
      rules: {
        type: [{required: true, message: "请选择用户类型", trigger: "change"}],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        companyName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        idNumber: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { validator: checkCardNo, trigger: 'blur' }
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: checkEmail, trigger: 'blur' }
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { validator: checkPhone, trigger: 'blur' }
        ],
        frontCard: [{required: true, message: "请上传身份证正面", trigger: "change"}],
        backCard: [{required: true, message: "请上传身份证背面", trigger: "change"}],
        mergeCard: [{required: true, message: "请上传手持身份证照片", trigger: "change"}],
        creditCode: [
          { required: true, message: "请输入社会信用代码", trigger: "change" },
          { validator: checkCreditCode, trigger: 'blur' }
        ],
        businessLicense: [{ required: true, message: "请上传营业执照", trigger: "change" }],
        licenseFile: [{ required: true, message: "请上传许可资质", trigger: "change" }],
      },
      sexOptions: [
        {
          value: 0,
          label: "女"
        },
        {
          value: 1,
          label: "男"
        }
      ],
      cardTypeOptions: [
        {
          value: 1,
          label: "身份证"
        },
        {
          value: 2,
          label: "护照"
        }
      ],
      typeOptions: [
        {value: '0', label: '个人'},
        {value: '1', label: '企业'}
      ],
      currIndex: null,
      openType: '',
      images: []
    };
  },
  created() {
    
  },
  computed: {
    ...mapGetters({
      storePersonList: "case/personList"
    })
  },
  watch: {
    openType: {
      immediate: true,
      handler(newValue) {
        switch (newValue) {
          case "see":
            this.title = "查看当事人信息";
            break;
          case "add":
            this.title = "新增当事人信息";
            break;
          case "edit":
            this.title = "编辑当事人信息";
            break;
          default:
            break;
        }
      }
    },
  },
  mounted() {
    
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);
          
          // 如果是新增案件的情况
          if (this.parentOpenType === 'add') {
            if (this.openType === 'add') {
              this.$store.commit('case/addPersonList', JSON.parse(JSON.stringify(this.ruleForm)));
            } else if (this.openType === 'edit') {
              console.log(this.currIndex);
              if (this.currIndex !== null) {
                this.$store.commit('case/editPerson', {
                  index: this.currIndex,
                  data: JSON.parse(JSON.stringify(this.ruleForm))
                });
              } else {
                throw Error('currIndex为空'); 
              }
            }
            this.ruleForm.name = '';
            this.close();
          } else {
            // 不是新增案件的情况
            this.updateOrAddPerson(this.ruleForm);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 新增或修改当事人
    updateOrAddPerson(reqData) {
      this.$api.updateOrAddPerson({
        contractId: this.contractId,
        ...reqData
      }).then(res => {
        if (res.data.code === '200') {
           if (this.openType === 'add') {
              this.$store.commit('case/addPersonList', JSON.parse(JSON.stringify(this.ruleForm)));
            } else if (this.openType === 'edit') {
              console.log(this.currIndex);
              if (this.currIndex !== null) {
                this.$store.commit('case/editPerson', {
                  index: this.currIndex,
                  data: JSON.parse(JSON.stringify(this.ruleForm))
                });
              } else {
                throw Error('currIndex为空'); 
              }
            }
            this.ruleForm.name = '';
            this.close();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    open(type, index) {
      this.visible = true;
      this.openType = type;
      console.log(this.parentOpenType, this.openType);
      if (index || index === 0) {
        this.currIndex = index;
        this.ruleForm = {...this.storePersonList[index]};
      }
    },
    close() {
      this.visible = false;
    },
    // 改变文件
    onChange(file,fileList) {
      console.log(file, fileList);
    },
    // 移除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // 上传身份证正面
    upLoadFront(data) {
      console.log(data);
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.frontCard = res.data.data.urf;
      })
    },
    // 上传身份证反面
    upLoadBack(data) {
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.backCard = res.data.data.urf;
      })
    },
    // 上传身份证反面
    upLoadMerge(data) {
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.mergeCard = res.data.data.urf;
      })
    },
    // 上传营业执照
    upLoadBusinessLicense(data) {
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.businessLicense = res.data.data.urf;
      })
    },
    // 上传许可资质
    upLoadLicenseFile(data) {
      let param = new FormData();
      param.append('file', data.file);
      this.$api.upLoadFile(param).then(res => {
        this.ruleForm.licenseFile = res.data.data.urf;
      })
    },
    inited (viewer) {
      this.$viewer = viewer
    },
    show(src) {
      this.images = [src];
      this.$viewer.show();
    },
  }
}
</script>
<style lang="less" scoped>
.orgForm{
  width: 80%;
  margin: 0 auto;
}
.el-form-item{
  margin-bottom: 12px;
}
.el-select {
    display: inline-block;
    position: relative;
    width: 100%;
}
.avatar-uploader{
  width: 150px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload {
    width: 150px;
    height: 100px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>